<template src="./ShareQRCode.html"></template>
  <script>
  import QRCode from "qrcodejs2"; //二维码
import loginService from "../../../plugin/extendFn/loginService";
  const weui = require('weui.js')


  /**
   * 分享二维码
   */
  export default {
    data() {
      return {
        wxuser: null,
        codeUrl:null,
        qrObject:null
      };
    },
    props: {},
    methods: {
        async getShareQRCodeKey(){
             /**
             * 1.必须是登录状态
             * 2.获取到用户的Id
             * 3.远程获取连接加密字符串
             * 4.生成二维码
             */
            //  this.wxuser={
            //     "shareQRCodeKey":"790aa76a858e4984a42e2c444f07bf6c"
            // }
            this.wxuser= await loginService.getLoginUser() ;
            console.log("wxuser >>> ",this.wxuser)
            if(this.wxuser)
            {
                return this.wxuser.shareQRCodeKey
            }
            else  // 没有登录，直接跳转到列表页
            {
                this.$router.push({
                    name:"Live"
                })
            }
        },
       async getCodeUrl(){
            var shareKey=await this.getShareQRCodeKey();
            this.codeUrl=null;
            if(shareKey)
            {
                var base=window.location.href.split("/ShareQRCode")[0];
                this.codeUrl=`${base}/index/live?shareKey=${shareKey}`
            }

            console.log(this.codeUrl);
        },
        async createQR(){
            /**
             * 1.必须是登录状态
             * 2.获取到用户的Id
             * 3.远程获取连接加密字符串
             * 4.生成二维码
             */
            await this.getCodeUrl();
            if(this.codeUrl)
            {
                 console.log('创建二维码');
                 this.qrObject = new QRCode(this.$refs.qrcode, {
                      text:this.codeUrl,
                      width: 200,
                      height: 200,
                      colorDark: "#333333", //二维码颜色
                      colorLight: "#ffffff", //二维码背景色
                      correctLevel: QRCode.CorrectLevel.H//容错率，L/M/H
                    });
            }
        },
        onClipboardSuccess(){
            this.$toast.success('复制成功!');
        },
        onClipboardError(){
            this.$toast('复制失败');
        },
        async createNew(){
            var shareKey=await this.getShareQRCodeKey();
            if(shareKey)
            {

                weui.confirm(`<div><span style="color:red">重新生成会将原来的链接和二维码置失效
                    导致用户无法再通过原来的链接和二维码进行登录
                    </span><br/><br/>
                    是否要生成新的连接和二维码?</div>
                    `, {
                    className:"ShareQRCode_confirm",
                    title: "提交确认",
                    buttons: [{
                        label: "取消",
                        type: 'default',
                        onClick: ()=>{
                            this.topTips("操作取消!")
                        }
                    }, {
                        label: "确定",
                        type: 'primary',
                        onClick: ()=>{
                            this.createNewHandler(shareKey);
                        }
                    }]
                });
            }
        },
        createNewHandler(shareKey){
            // 系统自动登录
            this.$postHttp(`/ra-app/api/share-qrcode/createNewKey/${shareKey}`).then(async (res) => {
                console.log("createNewKey >>> res=",res)
                var code=res.data.code;
                var userEntity=res.data.data;
                if (code == 0 && userEntity) {
                    // 存储上登录数据
                   await  loginService.setLoginUser(userEntity)
                    // 重新获取到登录信息!
                    this.wxuser= await loginService.getLoginUser()
                    // 获取到最新登录二维码
                   await this.getCodeUrl();
                    // 重新生成二维码
                    this.qrObject.makeCode(this.codeUrl)
                    this.$toast.success("已重新生成")
                }
                else{
                    this.topTips("重新生成失败，请重新登录!")
                }
            })
        }
    },
    computed: {},
    async  mounted() {
       await this.createQR();
    },
  };
  </script>
  <style scoped lang="scss" src="./ShareQRCode.scss">  </style>
  


// WEBPACK FOOTER //
// src/components/me/ShareQRCode/ShareQRCode.vue